import React, { useEffect, useContext, useState } from "react";
import { SuperSEO } from "react-super-seo";
import axios from "axios";
import { Card, Col, ListGroup, Row } from "react-bootstrap";
import PsContext from "../../../context";
import DepartmentLayout from "../../innerPageLayout/departmentLayout";

import { ServiceUrl } from "../../../utils/serviceUrl";
import { LOADER_LOGO } from "../../../utils";

const Department = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  return (
    <>
      {loader && (
        <center className="py-5">
          <img src={LOADER_LOGO.default} />
        </center>
      )}
      <DepartmentLayout {...props}></DepartmentLayout>
    </>
  );
};

export default Department;
